export var TransactionAmountType;
(function (TransactionAmountType) {
    TransactionAmountType["GROSS"] = "GROSS";
    TransactionAmountType["NET"] = "NET";
})(TransactionAmountType || (TransactionAmountType = {}));
//# sourceMappingURL=transaction-amount-type.enum.js.map